// extracted by mini-css-extract-plugin
export default {"martyBattContainer":"styles_martyBattContainer__0gvt6","martyBattPercentage":"styles_martyBattPercentage__qAfw3"};